__turbopack_context__.v({
  "alignCheckboxToTop": "checkbox-with-label-module-scss-module__UuQ6Ba__alignCheckboxToTop",
  "disabled": "checkbox-with-label-module-scss-module__UuQ6Ba__disabled",
  "filter": "checkbox-with-label-module-scss-module__UuQ6Ba__filter",
  "hasTooltip": "checkbox-with-label-module-scss-module__UuQ6Ba__hasTooltip",
  "input": "checkbox-with-label-module-scss-module__UuQ6Ba__input",
  "label": "checkbox-with-label-module-scss-module__UuQ6Ba__label",
});
